import { PortableTextBlock } from '@portabletext/react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Container, Section } from 'components/GridV2';
import { ShortArrow } from 'components/icons';
import CustomPortableText from 'components/rebrand/CustomPortableText';
import { H2 } from 'components/rebrand/Typography';

type Props = {
  heading: string;
  uses: {
    description: PortableTextBlock | PortableTextBlock[] | string;
    heading: string;
  }[];
  headingClassname?: string;
  variant?: 'dark' | 'light';
};

const WhyUse = ({ heading, uses, headingClassname, variant = 'dark' }: Props) => {
  const isLight = variant === 'light';
  return (
    <Section className={twMerge(clsx('bg-primary-500 py-64 md:py-96', isLight && 'bg-white'))}>
      <Container className="px-32 xs:px-0">
        <H2
          className={twMerge(
            'mx-auto mb-48 text-center text-white md:mb-64 md:w-3/5',
            isLight && 'text-primary-400',
            headingClassname,
          )}
        >
          {heading}
        </H2>

        <div className="grid grid-cols-1 gap-x-64 gap-y-32 md:grid-cols-2">
          {uses.map((use) => (
            <div key={use.heading} className="flex flex-row gap-16">
              <ShortArrow
                className={twMerge(
                  clsx('max-h-28 min-h-28 min-w-28 max-w-28 text-secondary-75', isLight && 'text-primary-200'),
                )}
              />
              <div className={twMerge(clsx('text-white [&_p]:text-md', isLight && 'text-grey-500'))}>
                <h3
                  className={twMerge(
                    clsx('pb-8 text-lg font-bold text-secondary-75 md:text-lg', isLight && 'text-primary-200'),
                  )}
                >
                  {use.heading}
                </h3>
                {typeof use.description === 'string' ? (
                  <p className="text-md leading-normal">{use.description}</p>
                ) : (
                  <CustomPortableText content={use.description} />
                )}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default WhyUse;
